import React from 'react';
import martrimonyLogo from '@/common/assets/images/LogoHeaer.png';
import styles from './index.module.less';

const Terms = () => {
  return (
    <div className={styles.maincontainer}>
      <div className={styles.headerload}>
        <img
          src={martrimonyLogo}
          alt="matrimony logo"
          className={styles.logostyles}
        />
      </div>
      <div className={styles.cookieRow}>
        <div className={styles.cookie}>
          <div className={styles.bgleft}></div>
        </div>
        <div className={styles.cookiecontainer}>
          <div className={styles.cookie_right}>
            <div className={styles.listview}>
              <h4>Cancellation and Refund Policy</h4>

              <h6>Introduction</h6>
              <p>
                This Cancellation and Refund Policy outlines the terms and
                conditions regarding cancellations and refunds for services
                provided by Elite Samskruti Matrimony Services (OPC) Private
                Limited (&quot;we,&quot; &quot;our,&quot; or &quot;us&quot;)
                through our website{' '}
                <a
                  href="https://www.samskrutimatrimony.com."
                  target="_blank"
                  rel="noreferrer"
                >
                  https://www.samskrutimatrimony.com.
                </a>
              </p>

              <h6>No-Refund Policy</h6>
              <p>
                We maintain a strict <b>no-refund policy</b> for all
                subscription plans. Once payment has been made for any of our
                subscription plans (Specialized or Elite), the amount paid is
                non-refundable under any circumstances, including but not
                limited to:
              </p>
              <ul>
                <li>
                  <p>Finding a match before the subscription period ends </p>
                </li>
                <li>
                  <p>Dissatisfaction with the service or available matches </p>
                </li>
                <li>
                  <p>Technical issues or website downtime</p>
                </li>
                <li>
                  <p>
                    Personal circumstances that prevent you from using our
                    services
                  </p>
                </li>
                <li>
                  <p>
                    Personal circumstances that prevent you from using our
                    services
                  </p>
                </li>
              </ul>

              <h6>Subscription Plans</h6>
              <p>Our subscription plans are as follows:</p>
              <p>
                <b>Specialized Plan:</b>
              </p>
              <ul>
                <li>
                  <p>Quarterly: INR 5,000 per user</p>
                </li>
                <li>
                  <p>Half-yearly: INR 9,000 per user</p>
                </li>

                <li>
                  <p>Yearly: INR 17,000 per user</p>
                </li>
              </ul>

              <p>
                <b>Elite Plan:</b>
              </p>
              <ul>
                <li>
                  <p>Quarterly: INR 22,500 per user</p>
                </li>
                <li>
                  <p>Half-yearly: INR 40,000 per user</p>
                </li>

                <li>
                  <p>Yearly: INR 65,000 per user</p>
                </li>
              </ul>
              <p>
                By purchasing any of these plans, you acknowledge and agree to
                our no-refund policy.
              </p>
              <h6>Cancellation of Subscription</h6>
              <p>
                While we do not offer refunds, you may cancel your subscription
                at any time to prevent automatic renewal. To cancel your
                subscription, please contact us at{' '}
                <a
                  href="mailto:samskrutimatrimony.com"
                  style={{ marginLeft: '4px' }}
                >
                  info@samskrutimatrimony.com
                </a>{' '}
                at least 7 days before your current subscription period ends.
              </p>
              <p>Please note that cancellation of your subscription:</p>
              <ul>
                <li>
                  <p>
                    Will not result in a refund for the current subscription
                    period
                  </p>
                </li>
                <li>
                  <p>
                    Will allow you to continue using our services until the end
                    of your current subscription period
                  </p>
                </li>
                <li>
                  <p>
                    Will prevent automatic renewal for the next subscription
                    period
                  </p>
                </li>
              </ul>
              <h6>Payment Processing Issues</h6>
              <p>
                In case of duplicate charges or technical errors in payment
                processing, please contact us immediately at
                info@samskrutimatrimony.com with relevant details and proof of
                the error. Such cases will be reviewed on an individual basis.
              </p>

              <h6>Service Modifications</h6>
              <p>
                We reserve the right to modify, suspend, or discontinue any
                aspect of our services at any time. Such modifications will not
                entitle users to a refund.
              </p>

              <h6>Force Majeure</h6>
              <p>
                We shall not be liable for any delay or failure to perform
                resulting from causes outside our reasonable control, including
                but not limited to acts of God, natural disasters, pandemic,
                war, terrorism, riots, embargoes, acts of civil or military
                authorities, fire, floods, accidents, strikes, or shortages of
                transportation facilities, fuel, energy, labor, or materials.
                Such events shall not entitle users to a refund.
              </p>

              <h6>Changes to This Policy</h6>
              <p>
                We reserve the right to modify this Cancellation and Refund
                Policy at any time. If we make material changes to this policy,
                we will notify you by email or by posting a notice on our
                website.
              </p>

              <h6>Contact Information</h6>
              <ul>
                <li>
                  <p>
                    If you have any questions about this Cancellation and Refund
                    Policy, please contact us at:
                  </p>
                </li>
                <li>
                  <p>
                    <b>Email:</b>
                    <a
                      href="mailto:info@samskrutimatrimony.com"
                      style={{ marginLeft: '4px' }}
                    >
                      info@samskrutimatrimony.com
                    </a>
                  </p>
                </li>
              </ul>
              <h6>Governing Law</h6>
              <p>
                This Cancellation and Refund Policy shall be governed by and
                construed in accordance with the laws of India, and any disputes
                shall be subject to the exclusive jurisdiction of the courts in
                Hyderabad, Telangana, India.
              </p>
              <p>
                By using our services, you acknowledge that you have read,
                understood, and agree to be bound by this Cancellation and
                Refund Policy.
              </p>
              <br></br>
              <p>
                <strong>Last Updated:</strong> 10th March 2025
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
